<template>
    <div class="file-bot-response" :class="{ empty: !defaultFileUrl }">
        <div class="placeholder" v-if="!defaultFileUrl && !selectedFile" @click="openSelectFile">
            <span class="material-icons"> attach_file </span>
            <span>{{ $t("chatbotv2.dragAndDropBrowseFile") }}</span>
        </div>
        <div
            v-else
            class="placeholder-wrapper position-relative"
            @mouseover="hovered = true"
            @mouseleave="hovered = false"
        >
            <span class="preview" :src="defaultFileUrl" v-if="defaultFileUrl && !uploading">
                <div class="media-content-wrapper">
                    <a :href="defaultFileUrl" download target="_blank">
                        <div v-if="getFile(defaultFileUrl)" :class="`fi-${getFile(defaultFileUrl)}`" class="fi">
                            <div class="fi-content">{{ getFile(defaultFileUrl) }}</div>
                        </div>
                        <p class="media-content-text">
                            {{ $t("message.download") }}
                        </p>
                    </a>
                </div>
            </span>
            <span class="preview" :src="selectedFileSrc" v-else-if="selectedFileSrc">
                <div class="media-content-wrapper">
                    <a :href="selectedFileSrc" download target="_blank">
                        <div v-if="getFile(selectedFileSrc)" :class="`fi-${getFile(selectedFileSrc)}`" class="fi">
                            <div class="fi-content">{{ getFile(selectedFileSrc) }}</div>
                        </div>
                        <p class="media-content-text">
                            {{ $t("message.download") }}
                        </p>
                    </a>
                </div>
            </span>
            <div class="uploading-banner" v-if="uploading">
                <a-progress
                    type="circle"
                    :stroke-color="{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                    }"
                    :percent="uploadProgress"
                />
                <span>{{ $t("chatbotv2.fileUploading") }} ...</span>
            </div>
            <div class="update-banner" v-if="defaultFileUrl && !uploading && hovered" @click="openSelectFile">
                <span class="material-icons"> attach_file </span>
                <span>{{ $t("chatbotv2.clickToChooseNewFile") }}</span>
                <span
                    >{{ $t("chatbotv2.or") }}
                    <span class="remove" @click="removeFile">{{ $t("chatbotv2.removeTheExistingOne") }}</span></span
                >
            </div>
        </div>
    </div>
</template>

<script>
import { getExtensionFromFileName } from "../../../../../../../utils/utils";
import log2 from "../../../../../../../utils/log2";
import { uploadAsset } from "../../../../../../../api/assetUpload";
import mimeTypes from "../../../../../../../components/util/mimeTypes";
import axios from "axios";
import { mapState } from "vuex";
import * as _ from "lodash";

const log = log2("FileBotResponse");
export default {
    name: "FileBotResponse",
    props: ["defaultFileUrl", "defaultAssetId", "onUpdated", "whatsappMode", "allowedAttributes"],
    data() {
        return {
            selectedFile: null,
            selectedFileSrc: null,
            uploading: false,
            uploadProgress: 0,
            hovered: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        getFile(fileName) {
            return getExtensionFromFileName(fileName);
        },
        openSelectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            // fileEl.setAttribute("accept", "image/*");

            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                if (file) {
                    const fileType = getExtensionFromFileName(file.name);
                    this.selectedFile = file;
                    this.selectedFileSrc = URL.createObjectURL(file);
                    this.uploading = true;
                    let path = `${this.site._id}/chatbot-file/`;

                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        ext: mimeTypes[file.type] || fileType || "supsis",
                        size: file.size,
                        type: "chatbot"
                    });
                    log("file", { file, data });
                    if (file.size <= 100 * 1024 * 1024) {
                        axios({
                            method: data.method,
                            url: data.url,
                            data: file,
                            headers: {
                                "Content-Type": file.type,
                            },
                            onUploadProgress: (p) => {
                                const percent = Math.round((p.loaded * 100) / p.total);
                                this.uploadProgress = percent;
                            },
                        })
                            .then((res) => {
                                this.$message.success({
                                    content: `File uploaded successfully`,
                                    duration: 2,
                                    key: "uploading",
                                });
                                this.onUpdated({
                                    assetId: data.asset._id,
                                    fileUrl: data.asset.v2Format && data.asset.cdnUrl
                                        ? data.asset.cdnUrl
                                        : `https://static.supsis.live/${data.asset.path}${data.filename}`,
                                });
                            })
                            .catch((err) => {
                                this.$message.error({
                                    content: "File upload failed",
                                    duration: 2,
                                    key: "uploading",
                                });
                            })
                            .finally(() => {
                                this.uploading = false;
                                this.selectedFile = null;
                                this.selectedFileSrc = null;
                                this.hovered = false;
                            });
                    } else {
                        log.warn("input is not suitable for send");
                        this.$message.error({
                            content: this.$t("message.assetOversizeMB", { mb: 100 }),
                            duration: 2,
                            key: "uploading",
                        });
                        this.uploading = false;
                        this.selectedFile = null;
                        this.selectedFileSrc = null;
                        this.hovered = false;
                    }
                } else {
                    this.selectedFile = null;
                    this.selectedFileSrc = null;
                    this.uploading = false;
                    this.hovered = false;
                }
            };
            fileEl.click();
        },
        removeFile(e) {
            e.preventDefault();
            e.stopPropagation();
            this.onUpdated({
                assetId: null,
                fileUrl: null,
            });
        },
    },
    watch: {
        defaultFileUrl(val) {
            log("defaultFileUrl changed", val);
        },
    },
};
</script>

<style scoped lang="scss">
@import "~css-file-icons";

.file-bot-response {
    max-width: 100%;
    width: 150px;
    height: 150px;
    border-radius: 8px;
    background: #f0f4f7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .placeholder-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .placeholder {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    span.preview {
        width: 150px;
        height: 150px;
        object-fit: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .media-content-wrapper {
            margin: 4px;

            .media-content-text {
                margin-bottom: 0;
                font-family: Poppins, monospace;
                margin-top: 6px;
                font-size: 12px;
                font-weight: 400;
                text-align: center;
            }
        }
    }

    .uploading-banner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(240, 244, 247, 0.99);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .update-banner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 108, 255, 0.6);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 12px;
        text-align: center;

        span {
            color: white;

            &.remove {
                text-decoration: underline;
            }
        }
    }

    &.empty {
        &:hover {
            cursor: pointer;
            background-color: #006cff;
            opacity: 0.8;
            color: white;

            .placeholder {
                color: white;
            }
        }
    }
}
</style>
